export const configuration = {
  title: 'Configuration templates',
  add: 'Add new configuration template',
  noResults: 'No data',
  newTitle: 'Create a new product configuration template',
  newSubtitle:
    'Pick the criteria this template applies to, then give it a name.',
  progress: 'Progress',
  criterionCounter: 'Criterion {position} of {total}',
  required: 'Required',
  optional: 'Optional',
  selectOneValue: 'Select one value to continue.',
  skipCriterionChoice: 'Skip this step',
  skipped: 'Skipped',
  summary: 'Summary',
  summaryHint: 'Name and settings',
  summaryDescription: 'Check the selected criteria and name the template.',
  noCriteriaSelected: 'No criteria selected',
  startOver: 'Start over',
  createTemplate: 'Create template',
  openEditor: 'Go to editor',
  newConfigurationName: 'New configuration template name',
  newNamePlaceholder: 'AE 86',
  configurationCreated: 'Configuration template has been created',
  configurationCreatedPara:
    'Would you like to go to the configuration template editing screen?',
  isDimmensionMode: 'Dimensions from model mode',
  modelFactorConversion: 'Model unit conversion',
  dimensionModeEnabledInfo:
    'Enabled: lengths are read default value, and the model unit conversion field is not editable.',
  dimensionModeDisabledInfo:
    'Disabled: you can manually set model unit conversion, which affects scene length and calculations.',
  dimensionModeEditInfo:
    'Scene length unit and conversion can be changed only for draft configuration with EDIT permission.',
  filters: {
    all: 'All',
    name: 'Search',
    status: 'Status',
    createdBy: 'Author',
    criterionValues: 'Criteria',
  },
  errorCreatedConfiguration: 'Configuration template was not created!',
}
